export var ExprForm;
(function (ExprForm) {
    ExprForm["Access"] = "ACCESS";
    ExprForm["Aggregate"] = "AGGREGATE";
    ExprForm["DatePart"] = "DATE_PART";
    ExprForm["DateTrunc"] = "DATE_TRUNC";
    ExprForm["Difference"] = "DIFFERENCE";
    ExprForm["PctDifference"] = "PCT_DIFFERENCE";
    ExprForm["PctOfTotal"] = "PCT_OF_TOTAL";
    ExprForm["Bin"] = "BIN";
    ExprForm["Generic"] = "GENERIC";
})(ExprForm || (ExprForm = {}));
(function (ExprForm) {
    let RelativeTo;
    (function (RelativeTo) {
        RelativeTo["Prev"] = "PREV";
        RelativeTo["Next"] = "NEXT";
        RelativeTo["First"] = "FIRST";
        RelativeTo["Last"] = "LAST";
    })(RelativeTo = ExprForm.RelativeTo || (ExprForm.RelativeTo = {}));
    let TotalUsing;
    (function (TotalUsing) {
        TotalUsing["Total"] = "TOTAL";
        TotalUsing["Avg"] = "AVG";
        TotalUsing["Max"] = "MAX";
        TotalUsing["Min"] = "MIN";
        TotalUsing["Sum"] = "SUM";
    })(TotalUsing = ExprForm.TotalUsing || (ExprForm.TotalUsing = {}));
    (function (TotalUsing) {
        function make(callName) {
            switch (callName.toUpperCase()) {
                case 'TOTAL':
                    return ExprForm.TotalUsing.Total;
                case 'WINDOW_AVG':
                    return ExprForm.TotalUsing.Avg;
                case 'WINDOW_MAX':
                    return ExprForm.TotalUsing.Max;
                case 'WINDOW_MIN':
                    return ExprForm.TotalUsing.Min;
                case 'WINDOW_SUM':
                    return ExprForm.TotalUsing.Sum;
            }
        }
        TotalUsing.make = make;
    })(TotalUsing = ExprForm.TotalUsing || (ExprForm.TotalUsing = {}));
})(ExprForm || (ExprForm = {}));
